<template>
    <div v-show="newsList.length" class="borad_wrap">
        <div class="borad" :class="[vip_open_comment ? 'borad_show' : 'borad_none']">
            <!-- <vue-seamless-scroll :data="newsList" :class-option="optionLeft" class="seamless-warp2">
                <ul class="item">
                    <li v-for="item in newsList" :key="item.id" v-text="item.content"></li>
                </ul>
            </vue-seamless-scroll> -->

            <ul class="item">
                <li v-for="item in newsList" :key="item.id" v-text="item.content"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        newsList:Array,
        vip_open_comment:Number,
    },
    data(){
        return{
            t:'讨论区',
        }
    },
    computed: {
        // optionLeft () {
        //     return {
        //             direction: 2,
        //             limitMoveNum: 2,
        //             openTouch:false,
        //             hoverStop:false,
        //             step:3,
        //             waitTime: 500, // 单步运动停止的时间(默认值1000ms)
        //         }
        // }
    },
    methods: {

    },
    mounted(){
        this.$nextTick(() => {
            $(function(){
                $('.item').liMarquee({
                    scrollamount:120,
                });
            });
        })

    }
}

</script>
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";


    .borad_wrap{
        position: relative;
        width: 100%;
        -webkit-overflow-scrolling: touch;
        font-size: 13px;
    }


    .borad{
        background: #FAFAFA;
        width: 100%;
        overflow: hidden;
        height: 50px;
        display: flex;
        align-items: center;
        
    }
    .borad_none{
        position: absolute;
        left: -10000000000px;
    }

    .borad_show{
        position: relative;
        left: unset;
    }


    // .seamless-warp2 {
    //     margin: 0 auto;
    //     overflow: hidden;
    //     height: rem(58px);
    //     width: 100%;
    //     margin-bottom: rem(30px);
    //     ul.item {
    //         display: flex;
    //         width: max-content;
    //         li {
    //             margin-right: rem(20px);
    //             font-size: rem(26px);
    //             height: rem(58px);
    //             line-height: rem(58px);
    //             padding: 0 rem(20px);
    //             border-radius: rem(29px);
    //             background: #fff;
    //             flex-shrink: 0;
    //             &:nth-of-type(even){
    //                 background:  #E2F3F6;
    //                 color: #65A8B0;
    //             }
    //             &:nth-of-type(odd){
    //                 background: #F9F4E6;
    //                 color: #C8AD5B;
    //             }
    //         }
    //     }
    // }
</style>

<style lang="scss">
.str_wrap {
	overflow:hidden;
	width:100%;
	position:relative;
	-moz-user-select: none;
	-khtml-user-select: none;
	user-select: none;  
	white-space:nowrap;
}

.str_wrap.str_active {
	
}
.str_move { 
	white-space:nowrap;
	position:absolute; 
	top:0; 
	left:0;
	cursor:move;
	display: flex;
}
.str_move li{ 
    margin-right: 10px;
    font-size: 13px;
    padding: 0 10px;
    height: 29px;
    display: flex;
    align-items: center;
    border-radius: 15px;
    background: #fff;
    flex-shrink: 0;
    &:nth-of-type(even){
        background:  #E2F3F6;
        color: #65A8B0;
    }
    &:nth-of-type(odd){
        background: #F9F4E6;
        color: #C8AD5B;
    }
}
.str_move_clone {
	display:inline-block;
	vertical-align:top;
	position:absolute; 
	left:100%;
	top:0;
}
.str_vertical .str_move_clone {
	left:0;
	top:100%;
}
.str_down .str_move_clone {
	left:0;
	bottom:100%;
}
.str_vertical .str_move,
.str_down .str_move {
	white-space:normal;
	width:100%;
}
.str_static .str_move,
.no_drag .str_move,
.noStop .str_move{
	cursor:inherit;
}
.str_wrap img {
	max-width:none !important;	
}
</style>